export default __webpack_public_path__ + "static/media/Vambraces of the Valiant.0ae6a746.jpg";